module.exports = __webpack_public_path__ + "img/welcome.37c366e5.svg";